// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_b75cc11","rulesLink":"_ade0037"};